/** Location state key for returning to a filtered list URL after create/edit/etc. */
export const LIST_RETURN_TO_KEY = 'listReturnTo'

export function currentListUrl(location: {
  pathname: string
  search: string
}): string {
  return `${location.pathname}${location.search}`
}

export function listReturnState(
  location: { pathname: string; search: string },
  extraState?: Record<string, unknown>,
): Record<string, unknown> {
  return {
    ...extraState,
    [LIST_RETURN_TO_KEY]: currentListUrl(location),
  }
}

export function getListReturnTo(state: unknown, fallback: string): string {
  if (state && typeof state === 'object' && LIST_RETURN_TO_KEY in state) {
    const value = (state as Record<string, unknown>)[LIST_RETURN_TO_KEY]
    if (typeof value === 'string' && value.startsWith('/')) {
      return value
    }
  }
  return fallback
}
